/**
 * @file Проверка возможностей потокового сохранения и предела Blob-способа.
 *
 * Без transferable streams локальный StreamSaver передаёт чанки по запросу worker.
 */
import { DownloadError, MEMORY_SAVE_LIMIT } from './model.ts'

export function validateMemorySave(size: number): void {
    if (size > MEMORY_SAVE_LIMIT) throw new DownloadError('memoryLimit')
}

export function streamingSaveAvailable(): boolean {
    if (!window.isSecureContext || !('serviceWorker' in navigator)) return false

    let channel: MessageChannel | undefined

    try {
        new Response(new TransformStream().readable)
        // Нужен немедленный abort ожидающей записи, до вызова sink.abort().
        let abortable = false
        new WritableStream({
            start: (controller) => {
                abortable = !!controller.signal?.addEventListener
            },
        })
        channel = new MessageChannel()

        return abortable
    } catch {
        return false
    } finally {
        channel?.port1.close()
        channel?.port2.close()
    }
}
